import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="csv-exporter"
export default class extends Controller {
  static targets = [
    "citySelect",
    "roadSelect",
    "animalClassSelect",
    "animalSpeciesSelect",
    "rangeSlider"
  ]

  connect() {
    // optional: console.log("Map download controller connected")
  }

  download(event) {
    event.preventDefault()

    const params = new URLSearchParams()

    // Seletores de filtro
    const city = document.querySelector('[data-map-target="citySelect"]')?.value
    const road = document.querySelector('[data-map-target="roadSelect"]')?.value
    const animalClass = document.querySelector('[data-map-target="animalClassSelect"]')?.value
    const animalSpecies = document.querySelector('[data-map-target="animalSpeciesSelect"]')?.value
    const streetOrCity = document.querySelector('input[name="street_or_city"]:checked')?.value
    const originSelect = document.querySelector('[data-map-target="originSelect"]')?.value

    const range = document.querySelector('[data-map-target="rangeSlider"]')
    const startYear = range?.dataset.startYear
    const startMonth = range?.dataset.startMonth
    const endYear = range?.dataset.endYear
    const endMonth = range?.dataset.endMonth

    // Adiciona parâmetros se existirem
    if (city) params.append("city", city)
    if (road) params.append("road", road)
    if (animalClass) params.append("animal_class", animalClass)
    if (animalSpecies) params.append("animal_species", animalSpecies)
    if (streetOrCity) params.append("street_or_city", streetOrCity)
    if (startYear) params.append("start_year", startYear)
    if (startMonth) params.append("start_month", startMonth)
    if (endYear) params.append("end_year", endYear)
    if (endMonth) params.append("end_month", endMonth)
    if (originSelect) params.append("origin", originSelect)

    // Redireciona para o endpoint de export
    window.location.href = `/pages/export?${params.toString()}`
  }
}
